import {defineStore} from 'pinia';
import {getToken} from '@/api';

const USER_NAME_STORAGE_KEY = 'user_name';
const USER_API_TOKEN_STORAGE_KEY = 'user_api_token';
const USER_API_REFRESH_TOKEN_STORAGE_KEY = 'user_api_refresh_token';
const SERVICE_PROVIDER_ID_STORAGE_KEY = 'service_provider_id';
const SERVICE_MEMBERSHIP_STORAGE_KEY = 'service_membership';

const storedServiceMembership = JSON.parse(localStorage.getItem(SERVICE_MEMBERSHIP_STORAGE_KEY) ?? '[]');

export const useUserStore = defineStore('user', {
    state: () => {
        return {
            name: localStorage.getItem(USER_NAME_STORAGE_KEY) ?? null,
            api_token: localStorage.getItem(USER_API_TOKEN_STORAGE_KEY) ?? null,
            refresh_token: localStorage.getItem(USER_API_REFRESH_TOKEN_STORAGE_KEY) ?? null,
            service_provider_id: localStorage.getItem(SERVICE_PROVIDER_ID_STORAGE_KEY) ?? null,
            serviceMemberships: storedServiceMembership,
        };
    },
    actions: {
        async login(credentials) {
            const response = await getToken(credentials);

            this.setLoginToken(response);
        },
        logout() {
            localStorage.removeItem(USER_NAME_STORAGE_KEY);
            localStorage.removeItem(USER_API_TOKEN_STORAGE_KEY);
            localStorage.removeItem(USER_API_REFRESH_TOKEN_STORAGE_KEY);
            localStorage.removeItem(SERVICE_PROVIDER_ID_STORAGE_KEY);
            localStorage.removeItem(SERVICE_MEMBERSHIP_STORAGE_KEY);

            this.name = null;
            this.api_token = null;
            this.refresh_token = null;
            this.service_provider_id = null;
            this.serviceMemberships = [];
        },
        setLoginToken(tokenData) {
            this.setAccessToken(tokenData.token);
            this.name = tokenData.name;
            this.refresh_token = tokenData.refresh;
            this.service_provider_id = tokenData.service_provider_id;

            localStorage.setItem(USER_API_REFRESH_TOKEN_STORAGE_KEY, tokenData.refresh);
            localStorage.setItem(SERVICE_PROVIDER_ID_STORAGE_KEY, tokenData.service_provider_id);
            localStorage.setItem(USER_NAME_STORAGE_KEY, tokenData.name);
        },
        setAccessToken(token) {
            this.api_token = token;
            localStorage.setItem(USER_API_TOKEN_STORAGE_KEY, token);
        },
        setServiceMemberships(serviceMemberships) {
            this.serviceMemberships = serviceMemberships;
            localStorage.setItem(SERVICE_MEMBERSHIP_STORAGE_KEY, JSON.stringify(serviceMemberships));
        },
    }
})
